import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const supportApi = createApi({
  reducerPath: "supportApi",
  tagTypes: ["Tickets"],

  baseQuery: fetchBaseQuery({
    baseUrl: "https://fetc.in/api/v1/supports",
    credentials: "include",
  }),

  endpoints: (builder) => ({
    /* ================= FETCH ================= */

    // ADMIN: get all tickets
    getAllTickets: builder.query({
  query: () => "/alltickets",
  transformResponse: (res) => {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.tickets)) return res.tickets;
    return [];
  },
  providesTags: (result) => {
    const list = Array.isArray(result) ? result : [];

    return list.length
      ? [
          ...list.map((t) => ({
            type: "Tickets",
            id: t._id,
          })),
          { type: "Tickets", id: "LIST" },
        ]
      : [{ type: "Tickets", id: "LIST" }];
  },
}),


    // USER / ADMIN: get single ticket
    getTicketById: builder.query({
      query: (id) => `/${id}`,
      providesTags: (r, e, id) => [{ type: "Tickets", id }],
    }),

    /* ================= USER ================= */

    // Create ticket
    submitTicket: builder.mutation({
      query: (data) => ({
        url: "/submit",
        method: "POST",
        body: data,
      }),
      invalidatesTags: [{ type: "Tickets", id: "LIST" }],
    }),

    // User reply
    replyToTicketUser: builder.mutation({
      query: ({ id, message }) => ({
        url: `/user/${id}/reply`,
        method: "POST",
        body: { message },
      }),
      invalidatesTags: (r, e, { id }) => [
        { type: "Tickets", id },
        { type: "Tickets", id: "LIST" },
      ],
    }),

    /* ================= ADMIN ================= */

    // Admin edit
    editTicket: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/edit/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (r, e, { id }) => [
        { type: "Tickets", id },
        { type: "Tickets", id: "LIST" },
      ],
    }),

    // Admin reply
    replyToTicketAdmin: builder.mutation({
      query: ({ id, message }) => ({
        url: `/admin/${id}/reply`,
        method: "POST",
        body: { message },
      }),
      invalidatesTags: (r, e, { id }) => [
        { type: "Tickets", id },
        { type: "Tickets", id: "LIST" },
      ],
    }),

    // Admin solve
    markTicketSolved: builder.mutation({
      query: (id) => ({
        url: `/admin/${id}/solve`,
        method: "PUT",
      }),
      invalidatesTags: (r, e, id) => [
        { type: "Tickets", id },
        { type: "Tickets", id: "LIST" },
      ],
    }),

    // Admin delete
    deleteTicket: builder.mutation({
      query: (id) => ({
        url: `/admin/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Tickets", id: "LIST" }],
    }),
  }),
});

export const {
  // queries
  useGetAllTicketsQuery,
  useGetTicketByIdQuery,

  // user
  useSubmitTicketMutation,
  useReplyToTicketUserMutation,

  // admin
  useEditTicketMutation,
  useReplyToTicketAdminMutation,
  useMarkTicketSolvedMutation,
  useDeleteTicketMutation,
} = supportApi;
